import { AsignafolioService } from './../../services/asigafolios/asignafolio.service';

import { Component, OnInit } from '@angular/core';
import { PescadorService } from './../../services/solicitante/pescador.service';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { SolicitanteService } from 'src/app/services/solicitante/solicitante.service';
import { Pescador } from './../../models/pescador';
import { forkJoin, pipe } from 'rxjs';
import { Router } from '@angular/router';
import { async } from '@angular/core/testing';
import { formatDate } from '@angular/common';
import { MatDialogRef } from '@angular/material';
import { PrecompraService } from 'src/app/services/precompra.service';
import { Solicitante } from 'src/app/models/solictante';
import * as moment from 'moment';


@Component({
  selector: 'app-reciboprecompra',
  templateUrl: './reciboprecompra.component.html',
  styleUrls: ['./reciboprecompra.component.css']
})
export class ReciboprecompraComponent implements OnInit {
  format = 'dd MMM yyyy';
  fechaActual: string;
  empresa: string;
  email: string;
  direccion: string;
  ciudad: string;
  estado: string;
  pipe: Date;
  totalsumatoriatabla: number;
  identificadousuario: string;
  listapescador: Pescador[];
  folioconsecututivoEfectivo = '';
  concepto: string;
  costoindividual: string ;

  numerorecibo: string;
  numerotocket: string;
  total: number;
  identificamovimiento: string;
  solicitante: Solicitante;

  cantidad: string;
  descripcion = 'Permmisos de Dia';
  Tottalpagar: string;

  pagina: string;
  stillUtc : any;

  constructor(
    private solicitanteService: SolicitanteService,
    private usuarioService: UsuarioService,
    private pescadorService: PescadorService,
    private precompraService: PrecompraService,
    private router: Router,
    private asignafolioService: AsignafolioService,
    public dialogRef: MatDialogRef<ReciboprecompraComponent>
  ) { }

  ngOnInit() {
    this.empresa = '';
    this.email = '';
    this.fechaActual = '';
    var date = moment.utc().format('YYYY-MM-DD HH:mm:ss');
 this.stillUtc = moment.utc(date).toDate();

    this.cantidad = '0';



    this.identificamovimiento = localStorage.getItem('idmovimiento');
    console.log ('entro a reportes del recibo prometido', this.identificamovimiento);
   //  this.localizaTicket();

  }



  crearReporte() {

    let doc = new jsPDF('p','mm','letter');

    const img = new Image();
    img.src = '../../../assets/logosmx.png';

    // doc.addImage(img, 'jpg', 10, 10, 100, 65);
    // doc.text('Recibo de Compra de Licencias en SportFishingMX :{{misdatos}}', 100, 70, 'center');



    doc.setLineWidth(3);
    // doc.setDrawColor(255, 0, 0);

   

    doc.setFillColor(0, 131, 185);
    doc.roundedRect(0, 0, 55, 280, 0, 0, 'F');
   // doc.roundedRect(110, valortop, 90, 41, 5, 5, 'F');

    const valortopinicial = 10;
    let valortop = valortopinicial ; // canbiabdo este numero se mueve todo hacia abajo

    // logo sportfishing
    doc.addImage(img, 'png', 3, valortop, 50, 44);

    console.log ('entro a reportes del recibo2');

    valortop = valortop + 60 ;  // cambiando este numero baja todo le texto bara abajo
    doc.setFontSize(15);
    doc.setFontType('bold');
    doc.text(8, valortop, 'SportfishingMX' );

    valortop = valortop + 4 ;  // cambiando este numero baja todo le texto bara abajo
    doc.setFontSize(8);
    doc.setFontType('normal');
    doc.text(13, valortop, 'www.sportfishingmx.com' );

    valortop = valortop + 5 ;  // cambiando este numero baja todo le texto bara abajo
    doc.setFontSize(8);
    doc.setFontType('normal');
    doc.text(13, valortop, 'info@sportfishingmx.com' );


    valortop = valortop + 10 ;
    doc.setFontSize(10);
    doc.setFontType('normal');
    doc.text(4, valortop, '511 E. San Ysidro Blvd. # 7129' );


    valortop = valortop + 4 ;
    doc.setFontSize(8);
    doc.text(13, valortop, 'San Ysidro, CA 92173' );

    // valortop = valortop + 10 ;
    // doc.setFontSize(10);
    // doc.text(10, valortop, 'Apartado Postal #24' );

    // valortop = valortop + 4 ;
    // doc.setFontSize(8);
    // doc.text(15, valortop, 'Rosarito B.C. 22710' );


    console.log ('entro a reportes del recibo13');

    valortop = valortopinicial ;


    valortop = valortop + 20 ;
    doc.setFontType('bold');
    doc.setFontSize(15);
    doc.text(115, valortop, 'Receipt' );


    valortop = valortop + 8 ;  // cambiando este numero baja todo le texto bara abajo
    doc.setFontSize(9);
    doc.setFontType('normal');
    doc.text(115, valortop, 'Confirmation Number' );

    valortop = valortop + 5 ; // cambinaod este numero es le espacio entre renglones
    doc.setFontSize(13);
    doc.text(115, valortop, this.numerotocket);

    valortop = valortop + 5 ;
    doc.setFontSize(9);
    doc.setFontType('normal');
    doc.text(115, valortop, 'Receipt Number' );

    valortop = valortop + 5 ;
    doc.setFontSize(13);
    doc.text(115, valortop, this.numerorecibo);

    valortop = valortop + 5 ;
    const locale = 'en-US';
    // const formattedDate = formatDate(this.fechaActual, this.format, locale);
    this.fechaActual = moment(this.stillUtc).local().format('YYYY-MM-DD HH:mm:ss'); // formatDate(this.fechaActual, this.format, locale);
 
    doc.setFontSize(9);
    doc.setFontType('normal');
    doc.text(115, valortop, 'Date' );

    valortop = valortop + 5 ;
    doc.setFontSize(13);
    doc.text(115, valortop, this.fechaActual);

    console.log ('entro a reportes del recibo4');


    valortop = valortop + 10 ;
    const espacios = 7;




    console.log ('entro a reportes del recibo5');


    const margen = 75;
    doc.setFontSize(12);
    doc.setFontType('bold');
    doc.text(margen, valortop, 'SOLD TO: ');
    doc.setFontSize(11);
    valortop += 10;
    doc.text(margen, valortop, this.empresa);
    doc.setFontType('normal');
    valortop += 5;
    doc.text(margen, valortop,  this.email);
    valortop += 5;
    doc.text(margen  , valortop,  this.direccion);
    doc.setFontType('normal');
    valortop += 5;
    doc.text(margen , valortop,  this.ciudad + ',' + this.estado );


    const posiciontopdetalles = valortop + 30 ;
    valortop = posiciontopdetalles;



   // valortop = posiciontopdetalles;

    doc.setLineWidth(.2);
    doc.roundedRect(margen, valortop, 130, 30, 3, 3, 'FD');
    doc.setFillColor(255, 255, 255);
    doc.setLineWidth(0);
    valortop = valortop + 10;
    doc.roundedRect(margen, valortop, 130, 36, 3, 0, 'FD');
    valortop = valortop + 9;
    doc.line(margen, valortop, 130 + margen, valortop);
    valortop = valortop + 9;
    doc.line(margen, valortop, 130 + margen, valortop);
    valortop = valortop + 9;
    doc.line(margen, valortop, 130 + margen, valortop);
    valortop = valortop + 9;
    doc.line(margen, valortop, 130 + margen, valortop);
    let ultimaposicion = valortop;


    valortop = posiciontopdetalles;

    doc.line(margen+62, valortop, margen+62, ultimaposicion);
    doc.line(margen+84, valortop, margen+84, ultimaposicion);
    doc.line(margen+106, valortop, margen+106, ultimaposicion);



    valortop = posiciontopdetalles + 7;

    console.log ('entro a reportes del recibo6');


    doc.setTextColor(255,255,255);
    doc.setFontSize(10);
    doc.setFontType('bold');
    doc.text(margen + 7, valortop, 'DESCRIPTION' );


    doc.setFontType('bold');
    doc.text(margen + 67, valortop, 'QTY' );


    doc.text(margen + 88, valortop - 2, 'UNIT' );
    doc.text(margen + 88, valortop + 1, 'PRICE' );


    doc.text(margen + 110, valortop, 'TOTAL' );





    console.log ('entro a reportes del recibo8');


    valortop = posiciontopdetalles;











    valortop = posiciontopdetalles ;

    doc.setTextColor(0, 0 , 0);

    valortop = valortop + 17 ;
    doc.setFontSize(14);

    let conceptoespanol = this.concepto.indexOf('Semana');
    if (conceptoespanol>0) {
        this.concepto =  "Week License Purchase"
    } else {
      let conceptoespanol = this.concepto.indexOf('Dia');
      if (conceptoespanol>0) {
        this.concepto =  "Day License Purchase"
      } else {
        let conceptoespanol = this.concepto.indexOf('Año');
        if (conceptoespanol>0) {
          this.concepto =  "Year License Purchase"
        }

    }
  }



    doc.text(margen + 3, valortop, this.concepto);
    doc.text(margen + 68, valortop, this.cantidad);
  //  let valorindividual = Number(this.Tottalpagar) / Number(this.cantidad);
    doc.text(margen + 92, valortop, this.costoindividual);





    doc.text(margen + 110, valortop, this.Tottalpagar);


    doc.setFontSize(18);
    doc.setFontType('bold');
    doc.text(margen + 40 , valortop + 42, 'Balance Paid (USD) $' + this.Tottalpagar);





    doc.save( this.numerorecibo + '.pdf');






}








   localizaTicket() {

   // this.cerrarventana();
    this.precompraService.buscamovimiento( this.identificamovimiento )
   .subscribe ( resp => {
      console.log ( 'este es la respuesta', resp);

      this.fechaActual = resp.precompra.fecha;
      this.numerorecibo = resp.movimiento[0].numeroperacion;
      this.concepto = resp.movimiento[0].concepto;
      this.numerotocket = resp.precompra.refenciapaypal;
      this.empresa = resp.precompra.idempresa.nombrempresa;
      this.email = resp.precompra.idempresa.email;
      this.direccion = resp.precompra.idempresa.direccion;
      this.ciudad = resp.precompra.idempresa.ciudad;
      this.estado = resp.precompra.idempresa.estado;

      const vcantidad: string = resp.precompra.clicencia;
      this.cantidad = vcantidad.toString();
      console.log ("recibo cantidad", this.cantidad);
      const vtotalpagar: string = resp.precompra.totalpagado;
      console.log ("recibo totalpagar", vtotalpagar);
      this.Tottalpagar = (Number(vtotalpagar).toFixed(2)).toString();
      console.log ("recibo tottpagar", this.Tottalpagar);

      this.costoindividual = (Number(vtotalpagar) / Number (vcantidad)).toFixed(2).toString();
      console.log ("recibo costoindividual", this.costoindividual);

      console.log ( 'sin problema', resp);
      this.crearReporte();

      this.cerrarventana();

   });



  }

  cerrarventana() {
    this.dialogRef.close();
   }



// haremos esta documenatcion ficticia para granar cambio


 }






 //     delay(ms: number) {
//    return new Promise( resolve => setTimeout(resolve, ms) );








